import { BrowserModule } from '@angular/platform-browser';
import { NgModule , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, SafePipe  } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { TitleCasePipe, CommonModule, DatePipe } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { ExcelService } from './services/excel.service';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';
import { SharingDataService } from './service/sharing-data.service';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { NavComponent } from './nav/nav.component';
import { LoginComponent } from './login/login.component';
import { OtpScreenComponent } from './otp-screen/otp-screen.component';
import { HomeComponent } from './home/home.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { RegistrationComponent } from './registration/registration.component';
import { AddFamilyRegComponent } from './add-family-reg/add-family-reg.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { AddInsuranceComponent } from './add-insurance/add-insurance.component';
import { MedicalsComponent } from './medicals/medicals.component';
import { AddMedicalComponent } from './add-medical/add-medical.component';
import { CheckInComponent } from './check-in/check-in.component';
import { HospitalLocatorComponent } from './hospital-locator/hospital-locator.component';
import { SettingsComponent } from './settings/settings.component';
import { CommonAuthGuard } from '../auth-gaurd/common-auth-guard';
import { LoginAuthGuard } from '../auth-gaurd/login-auth-gaurd';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { PlanLeaveComponent } from './plan-leave/plan-leave.component';
import {CalendarModule} from 'primeng/calendar';
import { TeamCheckInComponent } from './team-check-in/team-check-in.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SetProfileComponent } from './set-profile/set-profile.component';
import { ProfileComponent } from './profile/profile.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { TeamMemberLeaveCalenderComponent } from './team-member-leave-calender/team-member-leave-calender.component';
import { EditInsuranceDetailsComponent } from './edit-insurance-details/edit-insurance-details.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { HomeNewComponent } from './home-new/home-new.component';
import { LandingComponent } from './landing/landing.component';
import { YourPoliciesComponent } from './your-policies/your-policies.component';
import { PersonalAccidentComponent } from './personal-accident/personal-accident.component';
import { ClickToCallComponent } from './click-to-call/click-to-call.component';
import { DoctorsProfessionalIndemnityComponent } from './doctors-professional-indemnity/doctors-professional-indemnity.component';
import { FamilyHealthInsuranceComponent } from './family-health-insurance/family-health-insurance.component';
import { MotorInsuranceComponent } from './motor-insurance/motor-insurance.component';
import { PersonalAccidentProposalComponent } from './personal-accident-proposal/personal-accident-proposal.component';
import { InsuropediaResultComponent } from './insuropedia-result/insuropedia-result.component';
import {YourNewPoliciesComponent} from './your-new-polices/your-new-policies.component';
import {ECardsComponent} from './e-cards/e-cards.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsViewComponent } from './notifications-view/notifications-view.component';
import { ReferComponent } from './refer/refer.component';
import { ReferSuccessComponent } from './refer-success/refer-success.component';
import { TransactionResponseComponent } from './transaction-response/transaction-response.component';
import { AddPolicyComponent } from './add-policy/add-policy.component';
import { IntimateComponent } from './intimate/intimate.component';
import { EmailComponent } from './email/email.component';
import { ChatWithUsComponent } from './chat-with-us/chat-with-us.component';
import { LaunchOfferComponent } from './launch-offer/launch-offer.component';
import { ReferArticlesComponent } from './refer-articles/refer-articles.component';
import { ReferArticleDetailComponent } from './refer-article-detail/refer-article-detail.component';
import { DoctorsProfessionalIndemnityQuoteComponent } from './doctors-professional-indemnity-quote/doctors-professional-indemnity-quote.component';
import { WindowRef } from './service/WindowRef.service';
import { DoctorProfessionalTransactionStatusComponent } from './doctor-professional-transaction-status/doctor-professional-transaction-status.component';
import { DoctorProfessionalProposalComponent } from './doctor-professional-proposal/doctor-professional-proposal.component';
import { SubmissionComponent } from './submission/submission.component';
import { SubmissionDetailComponent } from './submission-detail/submission-detail.component';
import { CovidProtectionComponent } from './covid-protection/covid-protection.component';
import { CovidProtectionProposalComponent } from './covid-protection-proposal/covid-protection-proposal.component';
import { CovidProtectionTransactionComponent } from './covid-protection-transaction/covid-protection-transaction.component';
import { StatusComponent } from './status/status.component';
import { HealthInsuranceProposalComponent } from './health-insurance-proposal/health-insurance-proposal.component';
import { MotorGoDigitTransactionResponseComponent } from './motor-go-digit-transaction-response/motor-go-digit-transaction-response.component';
import { HealthInsuranceTransactionResponseComponent } from './health-insurance-transaction-response/health-insurance-transaction-response.component';
import { TermAndConditionComponent } from './term-and-condition/term-and-condition.component';
import { PolyclinicComponent } from './polyclinic/polyclinic.component';
import { SurgicalCareComponent } from './surgicalCare/surgicalCare.component';
import { FamilyHealthCareProposalComponent } from './family-health-care-proposal/family-health-care-proposal.component';
import { EcardsDetailComponent } from './ecards-detail/ecards-detail.component';
import { YourPolicyDetailsComponent } from './your-policy-details/your-policy-details.component';
import { SasaComponent } from './sasa/sasa.component';
import { MisComponent } from './mis/mis.component';
import { PartnerLeadComponent } from './partner-lead-form/partner-lead.component';
import { AgentComponent } from './agent-screen/agent.component';
import { RetrieveQuoteComponent } from './agent-screen/retrieve-quote/retrieve-quote.component';
import { DashboardComponent } from './agent-screen/dashboard/dashboard.component';
import { StatisticsComponent } from './agent-screen/statistics/statistics.component';
import { SeniorCitizenTransactionComponent } from './senior-citizen-transaction/senior-citizen-transaction.component'
import { HospitalCashComponent } from './hospital-cash/hospital-cash.component';
import { SeniorCitizenInsuarnceComponent } from './senior-citizen-insurance/senior-citizen-insurance.component';
import { SeniorCitizenQuoteComponent } from './senior-citizen-quote/senior-citizen-quote.component';
import { SeniorCitizenProposalFormComponent } from './senior-citizen-proposal-form/senior-citizen-proposal-form.component';
import { RazorpayComponent } from './razorpay/razorpay.component';
import { WalletComponent } from './wallet/wallet.component';
import { RequestedQuotesComponent } from './requested-quotes/requested-quotes.component'; 
import { ProgressComponent } from './progress/progress.component';
import { CommentHistoryComponent } from './comment-history/comment-history.component';
import { CommentComponent } from './comment/comment.component';
import { ViewcommentComponent } from './viewcomment/viewcomment.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { FirebaseMessagingService } from './services/firebase-messaging.service';
import { NotificationService } from './services/notification.service';
import { AuthExpiredInterceptor } from './services/auth-expired.interceptor';


export let browserRefresh = false;
import { ReferrallistComponent } from './referrallist/referrallist.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { CompleteRegistrationComponent } from './complete-registration/complete-registration.component';
import { HealthPackageComponent } from './health-package/health-package.component';
import { CosmeticSurgeryComponent } from './cosmetic-surgery/cosmetic-surgery.component';
import { DailyHospitalCashComponent } from './daily-hospital-cash/daily-hospital-cash.component';
import { ViewEndorsementsComponent } from './view-endorsements/view-endorsements.component';
import { TermLifeInfoComponent } from './term-life-info/term-life-info.component';
import { SuperTopupComponent } from './super-topup/super-topup.component';
import { OrderByPipe } from './pipes/order-by.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { HraComponent } from './hra/hra.component';
import { NewNotificationsComponent } from './new-notifications/new-notifications.component';

import { DropdownModule } from 'primeng/dropdown'
@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    LoginComponent,
    OtpScreenComponent,
    HomeComponent,
    ViewNotificationComponent,
    RegistrationComponent,
    AddFamilyRegComponent,
    InsurancesComponent,
    AddInsuranceComponent,
    MedicalsComponent,
    AddMedicalComponent,
    CheckInComponent,
    HospitalLocatorComponent,
    SafePipe,
    SettingsComponent,
    PlanLeaveComponent,
    TeamCheckInComponent,
    AboutUsComponent,
    SetProfileComponent,
    TeamMemberLeaveCalenderComponent,
    EditInsuranceDetailsComponent,
    HomeNewComponent,
    YourPoliciesComponent,
    PersonalAccidentComponent,
    ClickToCallComponent,
    DoctorsProfessionalIndemnityComponent,
    FamilyHealthInsuranceComponent,
    MotorInsuranceComponent,
    PersonalAccidentProposalComponent,
    InsuropediaResultComponent,
    YourNewPoliciesComponent,
    ECardsComponent,
    NotificationsComponent,
    NotificationsViewComponent,
    ReferComponent,
    ReferSuccessComponent,
    TransactionResponseComponent,
    AddPolicyComponent,
    IntimateComponent,
    EmailComponent,
    ChatWithUsComponent,
    ProfileComponent,
    EditProfileComponent,
    LaunchOfferComponent,
    ReferArticlesComponent,
    ReferArticleDetailComponent,
    DoctorsProfessionalIndemnityQuoteComponent,
    DoctorProfessionalTransactionStatusComponent,
    DoctorProfessionalProposalComponent,
    SubmissionComponent,
    SubmissionDetailComponent,
    CovidProtectionComponent,
    HealthInsuranceProposalComponent,
    CovidProtectionProposalComponent,
    CovidProtectionTransactionComponent,
    StatusComponent,
    HealthInsuranceProposalComponent,
    MotorGoDigitTransactionResponseComponent,
    HealthInsuranceTransactionResponseComponent,
    LandingComponent,
    TermAndConditionComponent,
    PolyclinicComponent,
    SurgicalCareComponent,
    FamilyHealthCareProposalComponent,
    EcardsDetailComponent,
    YourPolicyDetailsComponent,
    SasaComponent,
    PartnerLeadComponent,
    RetrieveQuoteComponent,
    AgentComponent,
    DashboardComponent,
    StatisticsComponent,
    MisComponent,
    SeniorCitizenTransactionComponent,
    HospitalCashComponent,
    SeniorCitizenInsuarnceComponent,
    SeniorCitizenQuoteComponent,
    SeniorCitizenProposalFormComponent,
    ThankYouComponent,
    RazorpayComponent,
    WalletComponent,
    RequestedQuotesComponent,
    ProgressComponent,
    CommentHistoryComponent,
    CommentComponent,
    ViewcommentComponent,
    ReferrallistComponent,
    CompleteRegistrationComponent,
    HealthPackageComponent,
    CosmeticSurgeryComponent,
    DailyHospitalCashComponent,
    ViewEndorsementsComponent,
    TermLifeInfoComponent,
    SuperTopupComponent,
    OrderByPipe,
    FilterPipe,
    HraComponent,
    NewNotificationsComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    NgxPaginationModule,
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    BrowserAnimationsModule,
    CarouselModule.forRoot(),
    NgChartsModule,
    DropdownModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDEO050WW2oVBD41FKAl3gSSIo9W_mnl3g'
    // }),
    ModalModule.forRoot(),
    
    NgMultiSelectDropDownModule.forRoot(),
    
   

   //ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  //  ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
   
   ServiceWorkerModule.register('firebase-messaging-sw.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    })
  ],
  providers: [
    LoginAuthGuard,
    CommonAuthGuard,
    TitleCasePipe,
    DatePipe,
    SharingDataService,
    WindowRef,
    ExcelService,
    FirebaseMessagingService,
    NotificationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    }

  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class AppModule { }
